import { RTCSessionEvent } from '@wui/jssip/lib/UA'

import { eventBus } from './event-bus'

export const onNewRTCSession = (e: RTCSessionEvent): void => {
  eventBus.emit('addSession', e)
}
